import clsx from "clsx";
import trim from "lodash/trim";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import { gettext } from "web/script/modules/django-i18n";
import { AccountLink } from "./account-links";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./account-links.module.css";

export default function NotificationsLink({
    url,
    notificationsCount,
}: AccountLink & { notificationsCount: number | null }): JSX.Element {
    const onClick = useClickTracker("icon", "clicked", trim(url as string, "/"));

    return (
        <div className={clsx(styles.glyph, "hidden-tablet")}>
            <a className={styles.icon} href={url} onClick={onClick}>
                <div className={styles.iconLink}>
                    <SVGIcon name="alerts-icon" />
                    {notificationsCount && notificationsCount > 0 ? (
                        <span
                            className={clsx(styles.notificationsCount, {
                                [styles.notificationsCountSmall]: notificationsCount > 99,
                            })}
                        >
                            {notificationsCount}
                        </span>
                    ) : null}
                </div>
                <div className={styles.iconText}>
                    {
                        // Alerts
                        gettext("notifications.title")
                    }
                </div>
            </a>
        </div>
    );
}
